import { createAction } from '@atc/modular-redux';

// Action Creators
import saveInventoryItemActionCreator from './saveInventoryItemActionCreator';
import unsaveInventoryItemActionCreator from './unsaveInventoryItemActionCreator';
import updateSavedInventoryItemActionCreator from './updateSavedInventoryItemActionCreator';
export default (duck, authDuck, personalization) => ({
  getLocalSavedInventory: () => async () => personalization.getSavedInventoryItems(),
  showUpdateSavedInventory: createAction(duck.types.SHOW_UPDATE_SAVED_INVENTORY),
  hideUpdateSavedInventory: createAction(duck.types.HIDE_UPDATE_SAVED_INVENTORY),
  setUpdateSavedInventoryState: createAction(duck.types.SET_UPDATE_SAVED_INVENTORY_STATE),
  showQuickSaveNotification: createAction(duck.types.SHOW_QUICK_SAVE_NOTIFICATION),
  hideQuickSaveNotification: createAction(duck.types.HIDE_QUICK_SAVE_NOTIFICATION),
  saveInventoryItem: saveInventoryItemActionCreator(duck, authDuck, personalization),
  setSavedInventoryItemByIndex: createAction(duck.types.SET_SAVED_INVENTORY_ITEM_BY_INDEX),
  unsaveInventoryItem: unsaveInventoryItemActionCreator(duck, authDuck, personalization),
  clearSavedInventory: createAction(duck.types.CLEAR_SAVED_INVENTORY),
  updateSavedInventoryItem: updateSavedInventoryItemActionCreator(duck, personalization),
  setSavedInventoryItems: createAction(duck.types.SET_SAVED_INVENTORY_ITEMS),
  setMaxQuickSavesLimit: createAction(duck.types.SET_MAX_QUICK_SAVES_LIMIT),
  setGlobalAlert: createAction(duck.types.SET_GLOBAL_ALERT),
  clearGlobalAlert: createAction(duck.types.CLEAR_GLOBAL_ALERT),
  updateSavedInventory: createAction(duck.types.UPDATE_SAVED_INVENTORY)
});